module.exports = __webpack_public_path__ + "media/images/landkit/icons/payment-methods/unionpay-b01da4d4010e9d898bd855228612f1f1.svg";